import { render } from "./Machine.vue?vue&type=template&id=7edb34b1"
import script from "./Machine.vue?vue&type=script&lang=ts"
export * from "./Machine.vue?vue&type=script&lang=ts"
script.render = render

export default script